module.exports = __webpack_public_path__ + "img/img_tutorial_08.0c9ed10d.svg";